var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "#fff",
    viewBox: "0 0 120 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#f9ba86"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 15,
    repeatCount: "indefinite",
    to: 15,
    values: "15;9;15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 1,
    repeatCount: "indefinite",
    to: 1,
    values: "1;.5;1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 15,
    r: 9,
    fill: "#f69e55",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 9,
    repeatCount: "indefinite",
    to: 9,
    values: "9;15;9"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 0.5,
    repeatCount: "indefinite",
    to: 0.5,
    values: ".5;1;.5"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 15,
    r: 15,
    fill: "#f48024"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 15,
    repeatCount: "indefinite",
    to: 15,
    values: "15;9;15"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "0.8s",
    from: 1,
    repeatCount: "indefinite",
    to: 1,
    values: "1;.5;1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.50b404596b0483a484963b773cf6b2b2.svg";
export { ForwardRef as ReactComponent };